// based on global configuration data and store specific configuration, enable or disable vton feature
import { selectConfiguration } from '../features/configuration/slice/selectors';
import { RootState, useAppSelector } from '../redux/store';
import { useSelector } from 'react-redux';

const useEnableVtonFeature = () => {
    const config = useAppSelector(selectConfiguration);
    const widgetStore = useSelector((state: RootState) => state.widget.store);
    return !!(config?.storeConfig?.enableTryOnFeature || widgetStore?.enableVtonFeature);
};

export default useEnableVtonFeature;
